module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-group element-bodymatter element-type-part element-with-heading",
    attrs: {
      "id": "part-1"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "part-1-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("El Paso")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "part-1-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('i', [_vm._v("The past is never dead. It’s not even past.")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("—William Faulkner, "), _c('i', [_vm._v("Requiem for a Nun")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("The river’s tent is broken: the last fingers of leaf")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Clutch and sink into the wet bank.")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("—T.S. Eliot, “The Waste Land”")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("And listen again to its sounds: get far enough away so that the noise of falling tons of water does not stun the ears, and hear how much is going on underneath—a whole symphony of smaller sounds, hiss and splash and gurgle, the small talk of side channels, the whisper of blown and scattered spray gathering itself and beginning to flow again, secret and irresistible, among the wet rocks.")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("—Wallace Stegner, “Overture,” in "), _c('i', [_vm._v("The Sound of Mountain Water")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ba9a948","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part001.vue
// module id = 81
// module chunks = 0